import { render, staticRenderFns } from "./WebPaymentNotificationBox.vue?vue&type=template&id=e342a8a0&scoped=true"
import script from "./WebPaymentNotificationBox.vue?vue&type=script&lang=js"
export * from "./WebPaymentNotificationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e342a8a0",
  null
  
)

export default component.exports